import { render } from "./EditRequest1.vue?vue&type=template&id=b08a5d0a"
import script from "./EditRequest1.vue?vue&type=script&lang=js"
export * from "./EditRequest1.vue?vue&type=script&lang=js"

import "./EditRequest1.vue?vue&type=style&index=0&id=b08a5d0a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__